import {
  CaesarsButton,
  Dropdown,
  FormField,
  GenericContainer,
  LoadingSpinner,
  Toast,
  ToastMessageContentItemType,
  ToastType,
  useIsDesktop,
} from '@eCommerce/frontend-legacy-shared-library-native';
import {yupResolver} from '@hookform/resolvers/yup';
import {useNavigation} from '@react-navigation/native';
import {ScrollView, Text, View} from 'native-base';
import React, {useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {useWindowDimensions} from 'react-native';
import * as Yup from 'yup';

import SuccessFooterBanner from 'components/SuccessFooterBanner';
import {Routes} from 'models/Navigation';
import {MatchTierResultCode} from 'services/api/affiliate';
import {APICallState, ResponseError} from 'services/api/api';
import {Partner} from 'store/affiliate/affiliate.reducer';

export interface LinkAffiliateAccountProps {
  partner: Partner | undefined;
  onLinkPress: (accountNumber: string) => void;
  apiError: ResponseError | undefined;
  apiState: APICallState;
}

interface Account {
  key: string;
  name: string;
}

const LinkAffiliateAccount = (props: LinkAffiliateAccountProps) => {
  const {partner, onLinkPress, apiError, apiState} = props;
  const isDesktop = useIsDesktop();
  const accounts = partner?.leapProperties.map(property => ({
    key: property.code,
    name: property.name,
  }));
  const [selectedAccount, setSelectedAccount] = useState<Account | undefined>(
    accounts?.[0]
  );
  const {navigate} = useNavigation();
  const {height} = useWindowDimensions();
  const dropdownMaxHeight = isDesktop ? `${height / 2}px` : `${height / 4}px`;
  const {
    handleSubmit,
    control,
    formState: {errors},
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {accountNumber: ''},
    resolver: yupResolver(
      Yup.object().shape({
        accountNumber: Yup.string()
          .required('Account number is required')
          .min(3, 'Please enter a valid account number'),
      })
    ),
  });

  const handleOnLinkPress = () => {
    handleSubmit(data => {
      onLinkPress(data.accountNumber || '');
    })();
  };

  return (
    <GenericContainer containerStyle={{padding: 48}}>
      <View maxWidth="324px" w="324px">
        <View>
          <Text fontSize="22px" fontFamily="heading" fontWeight="bold">
            LINK MY ACCOUNT
          </Text>
          <View h="16px" />
          {apiState === APICallState.LOADING ? (
            <LoadingSpinner />
          ) : apiState === APICallState.SUCCESS ||
            apiError?.resultCode === MatchTierResultCode.NOT_AVAILABLE ? (
            <View>
              <SuccessFooterBanner
                msg="Your account is successfully linked."
                isSuccess={true}
                shouldAnimate={false}
              />
              <View h="12px" />
              <CaesarsButton
                title="Return To Dashboard"
                onPress={() => navigate(Routes.Main.Home)}
              />
            </View>
          ) : (
            <>
              {apiState === APICallState.ERROR &&
                apiError?.resultCode !== MatchTierResultCode.NOT_AVAILABLE && (
                  <Toast
                    toast={{
                      type: ToastType.DANGER,
                      messageContent: [
                        {
                          elementType: ToastMessageContentItemType.TEXT,
                          text: apiError?.resultMessage || '',
                        },
                      ],
                    }}
                  />
                )}

              <Text mt="8px" mb="8px">
                Enter your account information
              </Text>
              <View mb={3}>
                <Dropdown
                  label="Account"
                  error=""
                  value={selectedAccount?.name}>
                  <ScrollView maxHeight={dropdownMaxHeight}>
                    {accounts?.map(item => (
                      <Dropdown.Item
                        key={`account-dropdown-${item.key}`}
                        onPress={() => setSelectedAccount(item)}>
                        {item.name}
                      </Dropdown.Item>
                    ))}
                  </ScrollView>
                </Dropdown>
              </View>
              <View mb="24px">
                <Controller
                  control={control}
                  name="accountNumber"
                  render={({field}) => (
                    <FormField
                      autoFocus
                      editable
                      nativeID="account-number-input"
                      label="ACCOUNT NUMBER"
                      testID="account-number-data"
                      onChangeText={field.onChange}
                      onBlur={field.onBlur}
                      value={field.value}
                      isInvalid={
                        !!errors?.accountNumber ||
                        (apiState === APICallState.ERROR &&
                          apiError?.resultCode === 'LEAP051003')
                      }
                      isInvalidLabel={
                        errors?.accountNumber?.message ||
                        'Account Number Not found'
                      }
                    />
                  )}
                />
              </View>
              <CaesarsButton
                buttonStyle={{alignSelf: 'flex-start'}}
                title="Link My Account"
                onPress={handleOnLinkPress}
              />
            </>
          )}
        </View>
      </View>
    </GenericContainer>
  );
};

export default LinkAffiliateAccount;
